import React, { useEffect, useState } from "react";
import { Container, Row, Col, Spinner, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../state/reducers/profile";
import "./profile.scss";
import TokenUsageTable from "./TokenUsageTable.jsx";
import { AtSign, Mail, UserRound } from "lucide-react";

const Profile = () => {
  const dispatch = useDispatch();
  const profileState = useSelector((state) => state.profile);
  const [userDetails, setUserDetails] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user?.username) {
        dispatch(getProfile({ username: user.username }));
        setUserDetails(user);
      }
    } catch (err) {
      setError("Failed to load user data");
      console.error("Error loading user data:", err);
    }
  }, [dispatch]);

  if (profileState?.loading) {
    return (
      <Container className="mt-4">
        <div className="text-center p-3">
          <Spinner animation="border" variant="primary" />
        </div>
      </Container>
    );
  }

  if (error || profileState?.error) {
    return (
      <Container className="mt-4">
        <Alert variant="danger">
          {error || profileState.error || "Failed to load profile data. Please try again."}
        </Alert>
      </Container>
    );
  }

  return (
    <div className="page-wrapper profile-page">
      <Container fluid>
        <Row>
          <Col>
            <div className="content-wrap">
              <h2 className="page-title">Profile</h2>
              <div className="profile-page-content">
                <div className="user-profile-wrapper">
                  <div className="user-details">
                    <div className="user-icon">
                      {userDetails?.fullname
                        ?.split(" ")
                        .map(name => name.charAt(0).toUpperCase())
                        .join("")}
                    </div>
                    <div className="user-info">
                      {/* <h3 className="mb-3">User Information</h3> */}
                      <div className="user-detail-info">
                        {userDetails?.fullname && (
                          <div className="user-row">
                            <div className="user-val profile-user-name">{userDetails?.fullname}</div>
                          </div>
                        )}
                        <div className="user-row mb-2">
                          <div className="label"><AtSign size={16} strokeWidth={1} /></div>
                          <div className="user-val">{userDetails?.username}</div>
                        </div>
                        <div className="user-row">
                          <div className="label"><Mail size={16} strokeWidth={1} /></div>
                          <div className="user-val">{userDetails?.email}</div>
                        </div>
                        <div className="user-row">
                          <div className="label"><UserRound size={16} strokeWidth={1} /></div>
                          <div className="user-val">{userDetails?.role}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <section className="token-wrapper">
                  <div className="d-flex align-items-start gap-3 mb-4">
                    <div className="w-100">
                      {profileState?.tokenData?.token_usage && (
                        <div className="mt-4">
                          <h2 className="mb-3">Token Usage Details</h2>
                          <TokenUsageTable data={profileState.tokenData} />
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </div>
              
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Profile;